const C = require("../constants");

const selectPartialOpenBox = (data) => {
    return {
        type: C.PARTIAL_OPEN_SELECT,
        data
    }
};

export {selectPartialOpenBox};


// WEBPACK FOOTER //
// ./src/actions/PartialOpenBoxSelectAction.js